var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forms"},[_c('h1',[_vm._v("This is an forms page")]),_vm._v(" a page that generate form from a ShEx shape and post it as an activityPub action."),_c('br'),_c('Crud')],1)}
var staticRenderFns = []

export { render, staticRenderFns }